export default __webpack_public_path__ + "static/media/item-1-safari-14.0522fab7.png";